import React, { useRef, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Icons } from '../helpers/utilities';
import Contact from '../contact/contact';

import * as Styled from './app.styles';

export default function ContactRoute() {
  const eContact = useRef(null),
    eAbout = useRef(null);

  useEffect(() => {
    eContact.current.scrollIntoView(true);
  }, []);

  return (
    <main>
      <section aria-label="Projects">
        <Link to="/projects">
          <Styled.Title>
            <Icons.Dash size="20" />
            <Styled.LineBg>Projects &amp; Partners</Styled.LineBg>
            <Icons.Expand size="30" color="#ff1493" />
          </Styled.Title>
        </Link>
      </section>
      <section aria-label="Contact">
        <Link to="/">
          <Styled.Title>
            <Icons.Dash size="20" />
            <Styled.LineBg ref={eContact}>Contact us</Styled.LineBg>
          </Styled.Title>
        </Link>
        <Contact />
      </section>
      <section aria-label="About">
        <Link
          to={{
            pathname: '/',
            state: { by: 'About' }
          }}
        >
          <Styled.Title>
            <Icons.Dash size="20" />
            <Styled.LineBg ref={eAbout}>About</Styled.LineBg>
            <Icons.Expand size="30" color="#ff1493" />
          </Styled.Title>
        </Link>
      </section>
    </main>
  );
}
